<!--
 * @Author: Viviyaaaa 870951135@qq.com
 * @Date: 2024-04-04 11:21:03
 * @LastEditors: Viviyaaaa 870951135@qq.com
 * @LastEditTime: 2024-04-09 11:44:21
 * @FilePath: \krpano-vue - 副本\src\components\Tools.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="hotspots">
    <ul>
      <li :class="['spot', curIdx === idx?'selected':'']" v-for="(item, idx) in spotsList" :key="item.title"  @click="clickToggleSpot(item, idx)">{{ item.title }}</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "AddHotspot",
  data() {
    return {
      spotsList:[
        {title:'交通配套', ygtype:'tab1', toH:'-87', toV:'19.119', fov:'84.032'},
        {title:'教育配套', ygtype:'tab2', toH:'-37.832', toV:'16.156', fov:'84.032'},
        {title:'商业配套', ygtype:'tab3', toH:'-34.405', toV:'24.187', fov:'84.032'},
        {title:'市政休闲', ygtype:'tab4', toH:'-65.688', toV:'18.460', fov:'84.032'},
      ],
      curIdx:0
      
    };
  },

  methods: {
    clickToggleSpot(item, idx){
      this.curIdx = idx
      // this.$EventBus.$emit('gotoHotspot',{
      //   type: item
      // }) 
    }
 
  },
};
</script>

<style lang="scss" scoped>
.hotspots {
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 5rem;
  left: 0;
  z-index: 100;
  border-radius: 5rem;
  .spot {
    width:5rem;
    line-height: 1.6rem;
    margin-bottom: 0.8rem;
    border: 1px solid #fff;
    border-radius: 0 30px 30px 0;
    background-color: rgba(0, 0, 0, 0.7);
    text-align: center;
    color:#fff;
    font-size: 12px;
    box-shadow: 0 3px 5px 0px rgba(0,0,0,0.6);
  }
  .selected {
    background-color:#666;
  }
}
</style>
